import React from 'react';
import { cn } from '../../utils/cn';

interface FaIconProps {
  iconName: string;
  className?: string;
}

export const FaIcon: React.FC<FaIconProps> = ({ iconName, className }) => {
  return (
    <i
      className={cn(`fa-solid ${iconName} flex h-4 w-4 items-center justify-center text-seapoint-gray-text`, className)}
    ></i>
  );
};
